/** Same rules as `@aimsos/ui` `normalizeChatMessageContent` so search offsets match rendered text. */
function messageContentToString(content) {
  if (typeof content === 'string') return content;
  if (Array.isArray(content)) {
    const textItems = content.filter((item) => item?.type === 'text' && item?.text);
    if (textItems.length > 0) return textItems.map((item) => item.text).join('\n\n');
    const fallback = content.find((item) => item?.text || item?.content || item?.message);
    return fallback ? fallback.text || fallback.content || fallback.message : '';
  }
  if (content && typeof content === 'object') {
    return content.message || content.content || content.text || content.formattedText || '';
  }
  return '';
}

/** @param {string} value */
export const escapeHtml = (value) =>
  String(value)
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;')
    .replace(/'/g, '&#039;');

const CLS_CURRENT =
  'rounded-sm bg-brand-200 px-0.5 font-medium ring-2 ring-inset ring-brand-600 dark:bg-brand-800 dark:ring-brand-400';
const CLS_OTHER = 'rounded-sm bg-amber-100 px-0.5 dark:bg-amber-900/50';

/**
 * @param {Array<{ content?: string }>} messages
 * @param {string} searchTerm
 * @returns {Array<{ messageIndex: number, start: number, end: number, globalIndex: number }>}
 */
export const findAllMatches = (messages, searchTerm) => {
  const term = searchTerm.trim().toLowerCase();
  if (!term) return [];

  const list = [];
  (messages || []).forEach((msg, messageIndex) => {
    const content = messageContentToString(msg?.content);
    const lower = content.toLowerCase();
    let pos = 0;
    let idx;
    while ((idx = lower.indexOf(term, pos)) !== -1) {
      list.push({
        messageIndex,
        start: idx,
        end: idx + term.length,
        globalIndex: list.length,
      });
      pos = idx + 1;
    }
  });
  return list;
};

/**
 * @param {string} content
 * @param {Array<{ start: number, end: number, globalIndex: number }>} matchesInMessage
 * @param {number} currentMatchIndex
 */
export const buildHighlightedHtml = (content, matchesInMessage, currentMatchIndex) => {
  if (!matchesInMessage.length) return escapeHtml(content);

  let html = '';
  let lastEnd = 0;
  matchesInMessage.forEach(({ start, end, globalIndex }) => {
    if (start > lastEnd) {
      html += escapeHtml(content.slice(lastEnd, start));
    }
    const slice = escapeHtml(content.slice(start, end));
    const className =
      globalIndex === currentMatchIndex
        ? `${CLS_CURRENT} highlight-current-js`
        : CLS_OTHER;
    html += `<span class="${className}">${slice}</span>`;
    lastEnd = end;
  });
  if (lastEnd < content.length) {
    html += escapeHtml(content.slice(lastEnd));
  }
  return html;
};
